
<template>
    <div class="modal-backdrop" @click.self="closeModal">
        <div class="modal-content-fullscreen">
            <!-- Bezáró gomb -->
            <!-- Fejléc sáv -->
            <div class="modal-header-bar">
                <span>Válassz csomagpontot</span>
                <button class="close-btn" @click="closeModal">
              <i class="fas fa-times"></i>
            </button>
            </div>

            <!-- Iframe wrapper -->

            <iframe :src="iframeSrc" frameborder="0" loading="lazy"></iframe>

        </div>
    </div>

    <!-- <div  class="iframe"  > -->
    <!-- <iframe frameborder="0" loading="lazy" src="https://cdn.foxpost.hu/apt-finder/v1/app/" width="100%" height="850"></iframe> -->
    <!-- <iframe frameborder="0" loading="lazy" src="https://cdn.foxpost.hu/apt-finder/v1/app/?desktop_height=550&tablet_width=600&tablet_height=350&mobile_width=400&mobile_height=350" width="100%" height="550"></iframe> -->

    <!--
            <v-select
            placeholder=""
            label="searchresult"
            @search="getOptions"
            v-model="selected"
            :debounce="250"
            :options="options"
            @input="consoleCallback">
        </v-select> -->
    <!-- <div v-if="error" class="alert alert-warning" role="alert">
            <button type="button" class="close" @click="error = null">
                <span aria-hidden="true">&times;</span></button>
                {{ error.message }}
            </div>
        > -->
</template>

<script type="text/babel">
function receiveMessage(event) {
    // if (event.origin !== 'https://cdn.foxpost.hu') {return};
    var apt = JSON.parse(event.data);

    console.log(apt.name, apt.findme);
}

//  window.addEventListener('message', receiveMessage, false);

export default {
    props: ['value', 'checkout', 'userdata_orig', 'shipping_method'],

    data() {
        return {
            iframeSrc: "https://cdn.foxpost.hu/apt-finder/v1/app/?desktop_height=550&tablet_width=600&tablet_height=350&mobile_width=400&mobile_height=350",
            selected: this.value,
            repo: null,
            error: null,
            options: [],
            userdata: Object.assign({}, this.userdata_orig)
        }
    },
    methods: {
        closeModal() {
            this.$emit('close');
        },

        handleMessage(event) {
            // Biztonsági ellenőrzés – csak a Foxpost domainről jövő üzenetet engedjük
            if (!event.origin.includes('foxpost.hu')) return;

            try {
                const apt = JSON.parse(event.data);
                this.selected = apt;
                if (apt && apt.name) {
                    console.log('Foxpost választott pont:', apt);

                    // Átadjuk a kiválasztott adatokat a checkout-nak
                    this.checkout.user.shipping_country = apt.country || this.userdata.shipping_country;
                    this.checkout.user.shipping_city = apt.city || this.userdata.shipping_city;
                    this.checkout.user.shipping_postcode = apt.zip || this.userdata.shipping_postcode;
                    this.checkout.user.shipping_address = apt.address || this.userdata.shipping_address;
                    this.checkout.user.shipping_name = apt.name;

                    // Ha szükséges, emit-eljük a kiválasztást
                    this.$emit('input', apt);

                    // Modal bezárása
                    this.closeModal();
                }
            } catch (e) {
                console.error('Hibás üzenet a Foxpost iframe-ből:', e);
            }
        },

    // consoleCallback(val) {
    //     console.log('consoleCallback():');
    //     console.log(val);
    //     if (val) {
    //          // console.log('if val != nulll');
    //         this.selected = val;

    //         this.$emit('input', val);

    //         // ne a csomagpont nev/cime legyen legyen, mert a csomagpont azonosito eleve atmegy
    //         this.checkout.user.shipping_country = val.country;
    //         this.checkout.user.shipping_city = val.city;
    //         this.checkout.user.shipping_postcode = val.zip;
    //         this.checkout.user.shipping_address = val.address;
    //         this.checkout.user.shipping_name = val.name;

    //         //  this.checkout.user.shipping_country = this.userdata.shipping_country ;
    //         // this.checkout.user.shipping_city = this.userdata.shipping_city ;
    //         // this.checkout.user.shipping_postcode = this.userdata.shipping_postcode;
    //         // this.checkout.user.shipping_address = this.userdata.shipping_address;
    //         // this.checkout.user.shipping_name = this.userdata.shipping_name;


    //     } else {
    //         // console.log('if val ..... else!');
    //         this.selected = '';
    //         this.$emit('input', null);

    //         this.checkout.user.shipping_country = this.userdata.shipping_country ;
    //         this.checkout.user.shipping_city = this.userdata.shipping_city ;
    //         this.checkout.user.shipping_postcode = this.userdata.shipping_postcode;
    //         this.checkout.user.shipping_address = this.userdata.shipping_address;
    //         this.checkout.user.shipping_name = this.userdata.shipping_name;

    //     }



    // },

},
mounted() {
        document.body.style.overflow = 'hidden';
        window.addEventListener('message', this.handleMessage);
    },

    beforeDestroy() {
        document.body.style.overflow = '';
        window.removeEventListener('message', this.handleMessage);
    }
}
</script>

<style scoped>
/* Fullscreen háttér */

.modal-backdrop {
    position: fixed;
    inset: 0;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1050000;
    overflow: hidden;
    /* háttér ne scrollozzon */
}

/* Fullscreen modal */

.modal-content-fullscreen {
    position: relative;
    width: 100%;
    height: 100vh;
    /* teljes viewport magasság */
    background: #fff;
    display: flex;
    z-index: 1050010;
    flex-direction: column;
    overflow: hidden;
}

/* Bezáró gomb */

.modal-header-bar {
    background-color: #0e0048;
    color: #ffffff;
    height: 3.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    font-weight: bold;
    position: relative;
    flex-shrink: 0;
    /* ne nyomódjon össze */
}

.close-btn {
    position: absolute;
    top: 0.6rem;
    right: 1rem;
    background: transparent;
    border: none;
    font-size: 1.5rem;
    color: #ffffff;
    /* fehér X */
    cursor: pointer;
    z-index: 1050040;
}

.modal-content-fullscreen iframe {
    flex: 1;
    width: 100%;
    height: 100%;
    border: 0;
    z-index: 1050030;
}
</style>
